import { render, staticRenderFns } from "./ClientPortfolio.vue?vue&type=template&id=a9f529ca&scoped=true&"
import script from "./ClientPortfolio.vue?vue&type=script&lang=js&"
export * from "./ClientPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./ClientPortfolio.vue?vue&type=style&index=0&id=a9f529ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f529ca",
  null
  
)

export default component.exports